<template>
  <div class="sl-header"><slot /></div>
</template>

<script>
export default {
  name: "RelHeader"
}
</script>
